import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Col, Collapse, Row } from 'reactstrap'

const CovidFaq = () => {

    const [open1,setOpen1] = useState(false)
    const [open2,setOpen2] = useState(false)
    const [open3,setOpen3] = useState(false)
    const [open4,setOpen4] = useState(false)
    const [open5,setOpen5] = useState(false)
    const [open6,setOpen6] = useState(false)
    const [open7,setOpen7] = useState(false)
    const [open8,setOpen8] = useState(false)
    const [open9,setOpen9] = useState(false)
    const [open10,setOpen10] = useState(false)
    const [open11,setOpen11] = useState(false)
    const [open12,setOpen12] = useState(false)
    const [open13,setOpen13] = useState(false)
    const [open14,setOpen14] = useState(false)

    const handleToggle1 = () => {
        setOpen1(!open1)
        console.log(open1)
    }

    const handleToggle2 = () => {
        setOpen2(!open2)
        console.log(open2)
    }

    const handleToggle3 = () => {
        setOpen3(!open3)
        console.log(open3)
    }

    const handleToggle4 = () => {
        setOpen4(!open4)
        console.log(open4)
    }

    const handleToggle5 = () => {
        setOpen5(!open5)
        console.log(open1)
    }

    const handleToggle6 = () => {
        setOpen6(!open6)
        console.log(open2)
    }

    const handleToggle7 = () => {
        setOpen7(!open7)
        console.log(open1)
    }

    const handleToggle8 = () => {
        setOpen8(!open8)
        console.log(open2)
    }

    const handleToggle9 = () => {
        setOpen9(!open9)
        console.log(open3)
    }

    const handleToggle10 = () => {
        setOpen10(!open10)
        console.log(open4)
    }

    const handleToggle11 = () => {
        setOpen11(!open11)
        console.log(open1)
    }

    const handleToggle12 = () => {
        setOpen12(!open12)
        console.log(open2)
    }

    const handleToggle13 = () => {
        setOpen13(!open13)
        console.log(open2) 
    }
    const handleToggle14 = () => {
        setOpen14(!open14)
        console.log(open2)
    }


  return (
    <div id='website-responsive' style={{ backgroundColor:'#' }}>

    {/* <div className='left-padding7rem1 right-padding7rem1 pt-5' style={{ marginTop:'', marginLeft:'' }}>
                <text className='fs-ss-30-1 text-ss-primary fw-800 text-raleway' style={{ letterSpacing:'0.9px'   }}>
                    Frequently Asked Questions
                </text>
            </div> */}
    
            <Row className=''>
                <Col className=''>
                <section className='' style={{ backgroundColor:'#f2f2f2'}}>
    
    <div className='left-padding5rem1 right-padding5rem1'>
    
        <div className='row mt-' id="faq-home">
    
            <div className='col-md-12 pb-md5 pt-md3 pb4 p-top-bottom2rem' style={{borderRadius:"", border:''}}>
                <div className='pb-4'>
                    <div className='fs-ss-36-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                        FAQs
                    </div>
                    <hr className='hr-style my-md-' style={{ width:'50px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>
    
                <Accordion className='borde' style={{ borderRadius:'0px', border:'none', backgroundColor:'#f2f2f2' }}>
    
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'', }} eventKey="0" >
    
                        <AccordionHeader onClick={() => handleToggle1()} style={{ color:'#f2f2f2'}}>
    
                            <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
                            How can I book an appointment for the Covid-19 test In Chicago?
                            </span>
    
                        </AccordionHeader>
    
                        <Collapse  isOpen={open1  ? true : false}>
                        <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                            <span className='fs-ss-15 text-montserrat fw-600 text-ss-black'>
    
                            You can schedule an appointment immediately through our website whenever convenient for you.                            </span>
    
                        </AccordionBody>
                    </Collapse>
                    </AccordionItem>
    
    
    
    
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'', }} eventKey="1" >
    
                        <AccordionHeader onClick={() => handleToggle2()} style={{ backgroundColor:'f2f2f2'}}>
    
                            <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                            Do I have to pay for Covid-19 tests?                            
                            </span>
    
                        </AccordionHeader>
                        <Collapse isOpen={open2 === true ? true : false}>
                        <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                            <span className='fs-ss-15 text-montserrat fw-600 text-ss-black'>
    
                            No, United Lab Care offers you the Covid-19 tests at no cost to you, if you have viable health insurance. Accepting Private Health Insurances, including Medicaid and Medicare. Otherwise, self-pay is also available.    
                            </span>
    
                        </AccordionBody>
                        </Collapse>
                    </AccordionItem>
    
    
    
    
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                        <AccordionHeader onClick={() => handleToggle3()}>
    
                            <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                            What kind of test is offered to diagnose an active COVID-19 infection?                            
                            </span>
    
                        </AccordionHeader>
                        <Collapse isOpen={open3 === true ? true : false}>
                        <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                            <span className='fs-ss-15 text-montserrat fw-600 text-ss-black'>
                            United Lab Care provides the Covid-19 testing solutions in Chicago with RT-PCR and Rapid Antigen tests without any cost to you.
                            </span>
    
                        </AccordionBody>
    </Collapse>
                    </AccordionItem>
    
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle4()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
                        What is the difference between the Rapid Antigen and PCR test?                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open4 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-15 text-montserrat fw-600 text-ss-black'>
                        Rapid Antigen tests are less reliable and accurate than PCR tests, although they deliver speedy results. The PCR test is more accurate, but patients have to generally wait for two to three days for results. 

</span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem>
    
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle5()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                        Is the PCR test painful?                    
                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open5 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-15 text-montserrat fw-600'>
                        The PCR test at United Lab Care is easy and painless although some slight irritation and discomfort may occur during the procedure.
                        </span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem>

                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle6()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                        Is the Covid-19 PCR Test reliable?                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open5 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-15 text-montserrat fw-600'>
                        The PCR test is reliable and effective because the professional team at United Lab Care uses high-quality covid kits.

</span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem>
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle7()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                        When will I get the results of the tests?                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open7 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-15 text-montserrat fw-600'>
                        You will receive test turnaround results in a short amount of time.
                        </span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem>

                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle8()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                            Do Covid-19 tests have any side effects?                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open8 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-15 text-montserrat fw-600'>
                        There is no indication that the COVID-19 diagnostic test has adverse side effects.
                        </span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem>
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle9()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                        What does RT-PCR stand for, and why is it significant?                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open9 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-15 text-montserrat fw-600'>
                        Real-time polymerase chain reaction (RT–PCR) is a nuclear-based approach for identifying the presence of specific genetic material in any disease, including viruses. It is used to measure the amount of RNA in the body using a real-time polymerase chain reaction test.
                        </span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem>

                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle10()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                            What type of Covid-19 tests are available at United Lab Care?                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open10 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-15 text-montserrat fw-600'>
                        At United Lab Care, we provide the RT-PCR and Rapid Antigen tests.
                        </span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem>
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle11()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                        Are there any significant consequences if I smoke Cigarettes during Covid-19?                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open11 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-15 text-montserrat fw-600'>
                        Cigarette smoking raises the likelihood of more severe COVID-19 disease, which might need hospitalization or intensive care.
                        </span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem>
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle12()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                        Is the Covid-19 test for children and adults the same?                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open12 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-15 text-montserrat fw-600'>
                        There is no difference between the COVID-19 diagnostic test for adults and for the children.
                        </span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem>
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle13()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                        Is it necessary for you to stay in quarantine for a more extended period if you have symptoms of Covid-19?                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open13 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-15 text-montserrat fw-600'>
                        There is a possibility that you may not have had symptoms when you initially tested positive for COVID-19, but they arose during your quarantine period. In that case, you should stay at home for at least one day after your fever has broken without the use of temperature-reducing medicines. It is advised to wait 24 hours after symptoms like cough and shortness of breath have also disappeared. You must follow the isolation requirements and stay for five days more in quarantine. For the sake of you and your loved ones.
                        </span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem>
    {/* 
                    <AccordionItem style={{ backgroundColor:'#f2f2f2', border:'1px solid #d4d4d4', }} eventKey="2" className=''>
    
                    <AccordionHeader onClick={() => handleToggle6()}>
    
                        <span className='fs-ss-16 text-ss-black fw-700 text-montserrat p-2' style={{fontWeight:"600"}}>
    
                        What is the Visit Schedule for Well-Children?
                        
                        </span>
    
                    </AccordionHeader>
                    <Collapse isOpen={open6 === true ? true : false}>
                    <AccordionBody className='p1' style={{ borderBottom:'1px solid black'}}>
    
                        <span className='fs-ss-16 text-roboto'>
                        <text className='fs-ss-16 text-roboto fw-700'>The visit schedule for well children is as follows:</text><br/><br/>
    
    Right after birth <br/>
    1 month <br/>
    2 months <br/>
    4 months <br/>
    6 months <br/>
    9 months <br/>
    12 months <br/>
    15 months<br/>
    18 months <br/>
    2 years <br/>
    3 years <br/>
    4 years <br/>
    5-10 years <br/>
    11 years <br/>
    12-15 years <br/>
    16 years <br/>
    17-18 years <br/> <br/>
    
    For more information, visit; well visits page.
                        </span>
    
                    </AccordionBody>
                    </Collapse>
                    </AccordionItem> */}
    
                    </Accordion> 
                    </div>
                    </div>
                    </div>
                    </section>
                    
                    </Col>
    
                
             
            
            </Row> 
    
             <div className='py-md-5 py-4  left-padding6rem right-padding6rem'>
                <div className='left-padding8rem right-padding8rem py-md-4' style={{ }}>
                    <div className='bg-img rounded30 pt-md-4' style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.5)', backgroundImage:'url("sti-testing/RSV-Testing-bg2.png")', width:'100%'}}>
                        <div className='p-4 px-md-5'>
                        <text className='fs-ss-26-5 text-montserrat text-white fw-600 lh-1-2 '>
                            <center>
                            Do you have Covid-19 symptoms or were in close contact with someone who has COVID-19?
                                <div className='pt-2'>
                                <hr className='hr-style my-md-2' style={{ width:'120px', marginTop:'2px', marginBottom:'4px'}}/>
                                </div>
                            </center>
                        </text>    
                        </div>
    
                        <div className='pb-4 pt-md-'>
                            <center>
                            <Link to='/book-covid-test-appointment'>
                                <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                    <text className='text-montserrat fw-600 fs-ss-16-1' style={{ padding:'',}}>
                                        Book Covid Test Now
                                    </text>
                                </Button>
                            </Link>
                            </center>
                        </div>
                    </div>
                </div>
                </div>      
        </div>
  )
}

export default CovidFaq